import React, { memo } from 'react';
import {
  StyledTextPairing,
  StyledColumns,
  StyledColumn,
  TopColumn,
  BottomColumn,
  StyledCloudImage,
  StyledBox,
  ValueTextPairing,
} from './HowWeWork.styles';
import { useTranslation } from 'react-i18next';

export const HowWeWorkContent: React.FC = memo(() => {
  const { t } = useTranslation('careers');
  const howWeWorkData = t('howWeWork');
  return (
    <>
      <StyledTextPairing
        eyebrow={howWeWorkData.eyebrow}
        eyebrowVariant="sectionEyeBrow24"
        eyebrowColor={'humana5'}
        eyebrowTagName="h3"
        title={howWeWorkData.title}
        titleVariant="hed72Hero"
        titleColor={'neutra6'}
        titleTagName="h2"
      />
      <StyledColumns>
        <StyledColumn width={5}>
          <StyledBox marginTop={[0, 10]} paddingTop={10} paddingBottom={[0, 10]}>
            <StyledCloudImage src="careers/how-we-work/pic1-v2.jpg" />
          </StyledBox>
        </StyledColumn>
        <StyledColumn width={6} offset={1}>
          <StyledBox marginTop={[0, 10]} paddingTop={10} paddingBottom={[0, 10]}>
            <ValueTextPairing
              title={howWeWorkData.designTitle}
              titleVariant="calloutHed40"
              titleColor="neutra6"
              titleTagName="h3"
              body={howWeWorkData.designBody}
              bodyVariant="dek24"
              bodyColor="neutra5"
            />
          </StyledBox>
        </StyledColumn>
      </StyledColumns>
      <StyledColumns>
        <TopColumn width={7}>
          <StyledBox marginTop={[0, 10]} paddingTop={10} paddingBottom={[0, 10]}>
            <ValueTextPairing
              title={howWeWorkData.workTitle}
              titleVariant="calloutHed40"
              titleColor="neutra6"
              titleTagName="h3"
              body={howWeWorkData.workBody}
              bodyVariant="dek24"
              bodyColor="neutra5"
            />
          </StyledBox>
        </TopColumn>
        <BottomColumn width={4} offset={1}>
          <StyledBox marginTop={[0, 10]} paddingTop={10} paddingBottom={[0, 10]}>
            <StyledCloudImage src="careers/how-we-work/pic2-v2.jpg" />
          </StyledBox>
        </BottomColumn>
      </StyledColumns>
    </>
  );
});
